<template>
  <div class="wrapper">
    <div class="container">
      <div class="form-group">
        <label>Datenquelle:</label>
        <select class="form-control" v-model="source.type" id="dstype">
          <option value="">-</option>
          <option value="referer">Vorlage</option>
          <option value="file">Lokale Datei</option>
          <option value="multifile">mehrere Dateien</option>
          <option value="filedir">Lokales Verzeichnis</option>
          <option value="http">HTTP</option>
          <option value="sql">Datenbank</option>
          <option value="cifs">Windows-Netzwerk-Datei</option>
          <option value="cifsdir">Windows-Netzwerk-Verzeichnis</option>
          <option value="script">Script</option>
        </select>
        <small class="form-text text-muted">Herkunft der Datenquelle auswählen</small>
      </div>
    </div>
    <div class="container">
      <!-- db source -->
      <div id="file-source" v-if="source.type == 'sql'">
        <strong>Datenbankverbindung</strong><br/>
        <div class="form-group">
          <label>Hostname:</label>
          <input class="form-control" v-model="source.hostname" type="text" />
        </div>
        <div class="form-group">
          <label>Port:</label>
          <input class="form-control" v-model="source.port" type="text" />
        </div>
        <div class="form-group">
          <label>Datenbank:</label>
          <input class="form-control" v-model="source.database" type="text" />
        </div>
        <div class="form-group">
          <label>Benutzer:</label>
          <input class="form-control" v-model="auth.username" type="text"/>
        </div>
        <div class="form-group">
          <label>Passwort:</label>
          <input class="form-control" v-model="auth.credentials" type="password"/>
        </div>
        <div class="form-group">
          <label>Treiber:</label>
          <select class="form-control" v-model="source.driver">
            <option value="org.postgresql.Driver">PostgreSQL</option>
            <option value="com.mysql.jdbc.Driver">MySQL</option>
            <option value="net.sourceforge.jtds.jdbc.Driver">MSSQL</option>
            <option value="sap.jdbc4.sqlanywhere.IDriver">SQL Anywhere</option>
          </select>
        </div>
        <div class="form-group">
          <label>Direkte JDBC URL:</label>
          <input class="form-control" v-model="source.jdbcval" type="text" />
          <small>Alternative URL Angabe für komplexere Treiberparameter</small>
        </div>
      </div>
      <!-- file source -->
      <div id="file-source" v-if="source.type == 'file'">
        <div class="form-group">
          <label>Dateipfad</label>
          <input class="form-control" v-model="source.uri" type="text"/>
        </div>
      </div>
      <!-- multi file source -->
      <div id="multi-file-source" v-if="source.type == 'multifile'">
        <div class="form-group">
          <label>Dateipfad</label>
          <input class="form-control" v-model="source.uri" type="text"/>
        </div>
        <div class="form-group">
          <label>Muster (RegEx)</label>
          <input class="form-control" v-model="source.pattern" type="text"/>
        </div>
      </div>
      <!-- http source -->
      <div id="http-source" v-if="source.type == 'http'">
        <div class="form-group">
          <label>URL:</label>
          <input class="form-control" v-model="source.url" type="text"/>
        </div>
        <div class="form-group">
          <label>Methode</label>
          <select class="form-control" v-model="source.method">
            <option value="get">GET</option>
            <option value="post">POST</option>
          </select>
          <span class="text-muted small">
            Bei POST Anfragen wird automatisch ein PagingScript vorausgesetzt, das neben einem "url" Attribute auch ein "data" und "contentType" Attribute im Ergebnis ("result" Objekt) zurück gibt.
          </span>
        </div>
        <div class="form-group">
          <label>Benutzer:</label>
          <input class="form-control" v-model="auth.username" type="text"/>
        </div>
        <div class="form-group">
          <label>Passwort:</label>
          <input class="form-control" v-model="auth.credentials" type="text"/>
        </div>
        <div class="form-group" v-show="auth.type==2">
          <label>Login URL:</label>
          <input class="form-control" v-model="auth.resource" type="text"/>
        </div>
        <div class="form-group" v-show="auth.type==2">
          <label>REST API Login Template</label>
          <textarea class="form-control" rows="3" v-model="auth.extend">
          </textarea>
          <span class="text-muted small">
            Geben Sie hier ein einfaches Template für die Login Anfrage ein z.B.: { "username":"$data.username", "password":"$data.credentials" }.
          </span>
        </div>
        <div class="form-group">
          <label>Auth-Methode:</label>
          <select class="form-control" v-model="auth.type">
            <option value="1">Basic</option>
            <option value="3">DigestAuth</option>
            <option value="2">JSON REST</option>
          </select>
        </div>
        <div class="row">
          <div class="col-sm">
            <label>HTTP Header</label>
            <div class="row">
              <div class="col-sm">
                <label>Name</label>
              </div>
              <div class="col-sm">
                <label>Wert</label>
              </div>
            </div>
            <div id="eflist">
                <div v-for="(value,key) in source.header" :key="key" class="row" name="efield">
                  <div class="col-sm">
                    <div class="form-group">
                      <input disabled name="name" type="text" class="form-control" :value="key"/>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group">
                      <div class="input-group">
                        <input name="value" type="text" class="form-control" :value="value"/>
                        <button name="remef" @click="remHttpHeader(key)" class="btn btn-danger"><strong>-</strong></button>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <input name="name" type="text" class="form-control" v-model="headerkey"/>
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <div class="input-group">
                <input name="value" type="text" class="form-control" v-model="headerval"/>
                <button @click="addHttpHeader" class="btn btn-primary" id="addef"><strong>+</strong></button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Paging Script</label>
              <div style="width:100%;height:500px;">
                <AceEditor editorId="httpScript" ref="pagingeditor" id="httpScript" lang="javascript" :content="source.paging"></AceEditor>
              </div>
              <span class="text-muted small">
                Das Paging Skript gibt über das "url" Attribute im "result" Objekt an, ob ein weiterer Request benötigt wird. Wird kein "url" Attribute zurückgegeben, wird der Lesevorgang abgebrochen.
                Für die Positionsinformationen kann die automatische Variable "context" genutzt werden mit get / set für einfache Abfragen. Die <a href="/help/scriptmodules/scriptinterfaces.html">Skript API</a> ist ebenfalls verfügbar.
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- dir source -->
      <div id="dir-source" v-if="source.type == 'filedir'">
        <div class="form-group">
          <label>Verzeichnis</label>
          <input class="form-control" v-model="source.path" type="text"/>
        </div>
        <div class="form-group">
          <input class="form-check-input" type="checkbox" v-model="source.recursive"/>
          <label>Rekursiv</label>
        </div>
        <div class="form-group">
          <label>Dateinamen Filter</label>
          <div class="input-group">
            <input placeholder="Regex zur Filterung der Dateieinträge" type="text" v-model="dirfilter" class="form-control" name="filterregex"/>
            <div class="input-group-append">
              <button @click="addDirFilter" class="btn btn-primary" name="addfilefilter">+</button>
            </div>
          </div>
          <select v-model="dirFilters" id="dirfilterlist" class="form-control" multiple="" size="6">
            <option v-for="f in source.filter" :key="f" :value="f">{{ f }}</option>
          </select>
          <button @click="remDirFilter" name="remfilefilter" class="btn btn-danger">-</button>
        </div>
        <div class="form-group mt-3">
          <label>Dateiauflistung als JSON Array mit einem JSON Objekt je Datei im Verzeichnis.</label>
          <ul class="list-group">
            <li class="list-group-item">name - Dateiname</li>
            <li class="list-group-item">path - vollständiger Dateipfad</li>
            <li class="list-group-item">size - Dateigröße</li>
            <li class="list-group-item">modified - Zeitstempel letzte Aktualisierung</li>
            <li class="list-group-item">type - Typ des Dateieintrages Verzeichnis (dir) oder Datei (file)</li>
          </ul>
        </div>
      </div>
      <!-- cifs source -->
      <div id="cifs-source" v-if="source.type == 'cifs'">
        <div class="form-group">
          <label>Netzwerkpfad:</label>
          <input class="form-control" v-model="source.url" type="text"/>
        </div>
        <div class="form-group">
          <label>Benutzer:</label>
          <input class="form-control" v-model="auth.username" type="text"/>
        </div>
        <div class="form-group">
          <label>Passwort:</label>
          <input class="form-control" v-model="auth.credentials" type="password"/>
        </div>
        <div class="form-group">
          <label>Zusatz (z.B. Domain)</label>
          <input class="form-control" v-model="auth.extend" type="text"/>
        </div>
      </div>
      <!-- cifs dir source -->
      <div id="cifs-dir-source" v-if="source.type == 'cifsdir'">
        <div class="form-group">
          <label>Netzwerkpfad:</label>
          <input class="form-control" v-model="source.url" type="text"/>
        </div>
        <div class="form-group">
          <input class="form-check-input" type="checkbox" v-model="source.recursive"/>
          <label>Rekursiv</label>
        </div>
        <div class="form-group">
          <label>Dateinamen Filter</label>
          <div class="input-group">
            <input placeholder="Regex für den Dateinamen zur Filterung" type="text" class="form-control" name="filterregex" v-model="dirfilter"/>
            <div class="input-group-append">
              <button @click="addDirFilter" class="btn btn-primary" name="addfilefilter">+</button>
            </div>
          </div>
          <select v-model="dirFilters" id="dirfilterlist" class="form-control" multiple="" size="6">
            <option v-for="f in source.filter" :key="f" :value="f">{{ f }}</option>
          </select>
          <button @click="remDirFilter" name="remfilefilter" class="btn btn-danger">-</button>
        </div>
        <div class="form-group">
          <label>Benutzer:</label>
          <input class="form-control" v-model="auth.username" type="text"/>
        </div>
        <div class="form-group">
          <label>Passwort:</label>
          <input class="form-control" v-model="auth.credentials" type="password"/>
        </div>
        <div class="form-group">
          <label>Zusatz (z.B. Domain)</label>
          <input class="form-control" v-model="auth.extend" type="text"/>
        </div>
        <div class="form-group mt-3">
          <label>Dateiauflistung als JSON Array mit einem JSON Objekt je Datei im Verzeichnis.</label>
          <ul class="list-group">
            <li class="list-group-item">name - Dateiname</li>
            <li class="list-group-item">path - vollständiger Dateipfad</li>
            <li class="list-group-item">size - Dateigröße</li>
            <li class="list-group-item">modified - Zeitstempel letzte Aktualisierung</li>
            <li class="list-group-item">type - Typ des Dateieintrages Verzeichnis (dir) oder Datei (file)</li>
          </ul>
        </div>
      </div>
      <!-- cifs dir source -->
      <div id="script-source" v-if="source.type == 'script'">
        <div class="form-group">
          <label>Script auswählen</label>
          <select class="form-control" v-model="source.paging">
            
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/modules/scripttasks.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'DataSourceEditor',
  components: {
    AceEditor
  },
  data() {
    return {
      source: { auth: {} },
      auth: { },
      headerkey: '',
      headerval: '',
      dirfilter: '',
      dirFilters: [],
    }
  },
  methods: {
    remHttpHeader: function(key) {
      if (this.source.header && this.source.header[key] !== undefined) {
        delete this.source.header[key];
        this.$forceUpdate();
      }
    },
    addHttpHeader: function() {
      if (!this.headerkey || this.headerkey == '') {
        this.$bvModal.toast('Bitte erst ein Http Header Namen eingeben!',{title:'Http Header',variant:'warning'});
        return;
      }
      this.source.header = this.source.header || {};
      this.source.header[this.headerkey] = this.headerval;
      this.headerkey = '';
      this.headerval = '';
      this.$forceUpdate();
      console.log('header done');
    },
    addDirFilter() {
      console.log(this.dirfilter);
      this.source.filter = this.source.filter || [];
      this.source.filter.push(this.dirfilter);
      this.$forceUpdate();
    },
    remDirFilter() {
      console.log(this.dirFilters);
      for (var i in this.dirFilters) {
        console.log(i);
        var s   = this.dirFilters[i];
        var idx = this.source.filter.indexOf(s);
        if (idx >= 0) {
          this.source.filter.splice(idx,1);
        }
      }
      this.$forceUpdate();
    },
    setSource: function(cfg) {
      if (!cfg.auth) {
          cfg.auth = {};
      } else {
          this.auth = cfg.auth;
      }

      this.source = cfg;
    },
    getSource() {
      if (this.auth) {
        this.source.auth = this.auth;
      }
      if (this.source.type == 'sql') {
        this.updateJDBC();
      }
      if (this.source.type == 'http') {
        this.source.paging = this.$refs.pagingeditor.getContent();
        console.log('set paging:',this.source.paging);
      }
      console.log('update source: ',this.source,this.auth);
      return this.source;
    },
    updateJDBC: function() {
      var jdbc;

      console.log('jval: ' + this.source.jdbcval);
      if (this.source.jdbcval !== undefined && this.source.jdbcval != '') {
        jdbc = this.source.jdbcval;
      } else {
        var d  = this.source.driver
        var du = '';
        if (d == 'org.postgresql.Driver') {
          du = 'postgresql';
        } else if (d == 'com.mysql.jdbc.Driver') {
          du = 'mysql';
        } else if (d == 'net.sourceforge.jtds.jdbc.Driver') {
          du = 'jtds:sqlserver'
        }

        jdbc = 'jdbc:' + du + '://' + this.source.hostname + ':' + this.source.port + '/' + this.source.database;
      }

      console.log(jdbc);
      this.source.jdbcUrl = jdbc;
    },
  }
}
</script>
